import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import CurrencyInput from 'react-currency-input-field';
import swal from '@sweetalert/with-react';
import dateFormater from '../Classes/FormatDate'
import formatTime from '../Classes/FormatTime';
import { getBGListDetails, postBGListDetails, UpdateBGStatusforBGRequestRequest, uploadBG, getactionDetail } from '../store/actions/expediting.Actions'
import { GetFilterList } from '../store/actions/masterActions'
import numberWithCommas from '../Classes/NumberwithComma'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Select, { components } from "react-select"
import AuthHandler from '../Classes/AuthHandler'
import env from '../ENV';
import Papa from 'papaparse';
import Loading from '../Components/Loader';
import toast from 'react-hot-toast';
// import { CSVLink } from "react-csv";
import SearchBar from '../Components/SearchBar'
import { Form, Button, InputGroup, FormControl, Card } from 'react-bootstrap';
import { getProjectAllocationByUserId } from '../store/actions/poDetailsActions';

const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}
function getDifferenceInDays(dateVal) {
    let today = new Date();
    let DateVal = new Date(dateVal)
    const diffInMs = Math.abs(DateVal - today);
    return Math.round(diffInMs / (1000 * 60 * 60 * 24));
}
class BGList extends Component {
    constructor() {
        super();
        this.state = {
            addDocumentmodal: false,
            BGModal: false,
            requestType: "",
            select: false,
            OpenInFoModal: false,
            BGAvtivityModal: false,
            newRecord: {},
            editIndex: -1,
            tableData: [],
            BgRemarks: "",
            BGItemSelect: [],
            BGUpload: {},
            csvFile: [],
            bgUploadDocumentmodal: false,
            CurrencyArray: [
                { value: "INR", label: "INR" },
                { value: "EUR", label: "EUR" },
                { value: "USD", label: "USD" },
                { value: "CNY", label: "CNY" }],
            selectedCurrency: "",
            SelectCurrencyArray: [],
            loadingData: false,
            csvData: [],
            searchForOptions: [
                { label: 'Currency', value: 'Currency' },
                { label: 'Guarantee No.', value: 'Guarantee No.' },
                { label: 'BG Type', value: 'BG Type' },
                { label: 'Business Area', value: 'Business Area' },
                { label: 'BG Amount', value: 'BG Amount' },
                { label: 'Old BG No.', value: 'Old BG No.' },
                { label: 'Vendor Code', value: 'Vendor Code' },
                { label: 'PO Number', value: 'PO Number' },
                { label: 'Bank Name', value: 'Bank Name' },
                { label: 'Pincode', value: 'Pincode' },
                { label: 'Project Code', value: 'WBS' },
            ],
            searchForItem: [],
            searchTerm: '',
            isShowFilter: false,
            finalvendorlist: [],
            finalpos: [],
            finalwbsno: [],
            finalplantcode: [],
            PlantCode: [],
            WBSCode: [],
            POSAPId: [],
            VendorName: [],
            sortByWBS: [],
            sortByPlantCode: [],
            sortByVendor: [],
            sortByPo: [],
            checkedArray: [],
            selected: [],
            selectedBGRow: {},
            ActivityComment: "",
            activityStatus: "",
            activityAction: "",
            activityId: 0,
            err: {}
        }
        this.checkboxAll = this.checkboxAll.bind(this);
        this.requestBGRequest = this.requestBGRequest.bind(this);
    }
    componentDidMount = async () => {
        let roles = AuthHandler.getRoles()
        let userId = AuthHandler.getUserID()
        if (roles[12]) {
            let sortByWBS = []
            let WBSCode = []
            await this.props.getProjectAllocationByUserId({ UserId: userId })
            let ProjectCodes = await this.props.poDetails.getProjectAllocationByUserId
            if (ProjectCodes.length > 0) {
                ProjectCodes.map((elem) => {
                    sortByWBS.push(elem.ProjectCode)
                    WBSCode.push({ label: elem.ProjectCode, value: elem.ProjectCode })
                })
            }
            await this.setState({ sortByWBS, WBSCode })
        }
        await this.dataSync()
        await this.getFilterList()
    }
    dataSync = async () => {
        this.setState({ loadingData: true })
        await this.props.getBGListDetails() // api to get the data regarding BG list
        let tableData = await this.props.expediting.bgDetails.recordset // to store the fetched data through api into variable
        let csvData = []
        // await tableData.map((item) => {
        //     csvData.push({
        //         "Doc. Date": dateFormater(item.Document_Date),
        //         "Posting Date": item.approvedOn,
        //         "BG Type": item.BGType,
        //         "Guarantee No.": item.Gurantee_No,
        //         "Currency": item.Currency,
        //         "Spl G/L indicator": item.Spl_GL_Indicator,
        //         "Business Area": item.Bussiness_Area,
        //         "Entity Name": item.EntityName,
        //         "BG Amount": numberWithCommas(item.BG_Amount),
        //         "Old BG no.": item.OLDBG_No,
        //         "Vendor Code": item.VendorSAPId,
        //         "Expiry date": dateFormater(item.Expiry_Date),
        //         "Purchase order no": item.PurchaseOrderNo,
        //         "Claim Date": dateFormater(item.Claim_Date),
        //         "Bank Name": item.Bank_Name,
        //         "Branch Email": item.Branch_Email,
        //         "Address 1": item.Address_1,
        //         "Address 2": item.Address_2,
        //         "City": item.City,
        //         "Pincode": item.PinCode,
        //         "Country": item.Country,
        //         "Supplier Name": item.SupplierName,
        //         "BG Confirmation Remarks": item.BGConfirmationRemarks,
        //     })
        // })
        await this.setState({
            tableData, csvFile: [], loadingData: false, csvData, checkedArray: [],
            selected: [], select: false, OpenInFoModal: false, selectedBGRow: {}, BGAvtivityModal: false, ActivityComment: "",
            activityStatus: "",
            activityAction: "", activityId: 0, err: {}
        })
        document.getElementById("BGUpload").value = "";
    }
    //Open Modal-------------------
    addDocumentmodal = async (data = {}, index = "") => {
        console.log(data, "cvcvcvcvc===========>")
        let SelectCurrencyArray = [{ "value": data.Currency, "label": data.Currency }]
        await this.setState({ newRecord: data, SelectCurrencyArray, editIndex: index, addDocumentmodal: !this.state.addDocumentmodal });
        console.log("this.state.newRecord", this.state.newRecord)
        if (this.state.addDocumentmodal == true) {
            this.setState({ opacity: "" })
        }
        else {
            await this.setState({ opacity: "0.2" })
        }
    }

    handleText = (e) => {
        let val = e.target.value
        let key = e.target.name
        let obj = { ...this.state.newRecord, [key]: val }
        console.log(obj)
        this.setState({ newRecord: obj })
    }

    handlvalueText = (value, name) => {
        console.log(value, name)
        let obj = { ...this.state.newRecord, [name]: value }
        this.setState({ newRecord: obj })
    }
    handleTextUpload = (e) => {
        let val = e.target.value
        let key = e.target.name
        let obj = { ...this.state.BGUpload, [key]: val }
        console.log(obj)
        this.setState({ BGUpload: obj })
    }

    handlvalueTextUpload = (value, name) => {
        console.log(value, name)
        let obj = { ...this.state.BGUpload, [name]: value }
        this.setState({ BGUpload: obj })
    }

    handleSaveItem = async () => {
        await this.props.postBGListDetails(this.state.newRecord)
        await this.dataSync()
        await this.addDocumentmodal()
    }
    BGModal = async () => {
        this.setState({ BGModal: !this.state.BGModal, CurrencyInput: "" });
        if (this.state.BGModal == true) {
            this.setState({ opacity: "" })
        }
        else {
            await this.setState({ opacity: "0.2" })
        }
    }
    handleCsv = async (event) => {
        var regex = new RegExp("(.*?)\.(csv)$");
        if (!(regex.test(event.target.value.toLowerCase()))) {
            event.target.value = '';
            swal("Please upload the file you have downloaded from the system", { icon: "error" })
            return false
        }
        let csvFile = event.target.files[0]
        await this.setState({ csvFile })
        console.log("Files-data", this.state.csvFile)
    }
    uploadCsv = async () => {
        if (this.state.csvFile.length == 0) {
            swal("Please select a file to upload", { icon: "error" })
            return false
        }
        await Papa.parse(this.state.csvFile,
            {
                header: true,
                complete: async (results) => {
                    await this.setState({ loadingData: true })
                    var count = 0
                    var error = false
                    for (let i = 0; i < results.data.length - 1; i++) {
                        await this.props.uploadBG(results.data[i])
                        count = count + 1
                        if (this.props.expediting.bgUpload && this.props.expediting.bgUpload.status == 400) {
                            console.log(this.props.expediting, "this.props.expediting")
                            error = true
                            break
                        }
                    }
                    if (error) {
                        swal(this.props.expediting.bgUpload.data.message, { button: false, icon: "error", timer: '2000' })
                    } else {
                        swal(`${count} records Successfully Uploaded!`, { button: false, icon: "success", timer: '2000' })
                    }
                    await this.dataSync()
                    await this.bgUploadDocumentmodal()
                }
            })
    }
    bgUploadDocumentmodal() {
        this.setState({ bgUploadDocumentmodal: !this.state.bgUploadDocumentmodal });

        if (this.state.bgUploadDocumentmodal == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }
    handleSelectCurrency = async (e) => {
        let selectedCurrency = e.value
        let SelectCurrencyArray = []
        SelectCurrencyArray.push(e)
        let obj = { ...this.state.newRecord, ['Currency']: e.value }
        await this.setState({ selectedCurrency, SelectCurrencyArray, newRecord: obj })
    }
    handleSelectSearchFor = async (value) => {
        let searchFor = value
        let searchForItem = [
            {
                label: value, value: value
            }
        ]
        await this.setState({ searchFor, searchForItem })
    }
    handleISearch = (e) => {
        let searchTerm = e.target.value
        this.setState({
            searchTerm
        })
        console.log(this.state.searchTerm)
    }
    handleSearching = async () => {
        await this.filterData()
    }
    filterData = async () => {
        await this.setState({ loadingData: true })
        let tableData = []
        let searchData = {
            searchTerm: this.state.searchTerm,
            searchFor: this.state.searchFor,
            sortByPlantCode: this.state.sortByPlantCode,
            sortByPo: this.state.sortByPo,
            sortByVendor: this.state.sortByVendor,
            sortByWBS: this.state.sortByWBS,
        }

        await this.props.getBGListDetails(searchData) // api to get the data regarding BG list
        tableData = await this.props.expediting.bgDetails.recordset
        await this.setState({ tableData, loadingData: false })
    }


    async OpenInFoModal(item) {
        console.log(item, "this.state.uploadID")
        await this.props.getactionDetail(item)
        console.log(this.props.expediting, "sdkhfbkhsdbfkbdskjfbksbdf")

        // if(this.props.expediting && this.props.expediting.bgRequestacton){
        let stateVal = this.state.OpenInFoModal;
        this.setState({ OpenInFoModal: !stateVal, selectedBGRow: item });
        // }
        // else{
        //     toast.error(`Something went wrong, Please try again`, {
        //         duration: 1000
        //     });
        //     await this.dataSync()
        //     return false;
        // }

    }

    changeCheckBoxStatus(index) {
        var checkedArray = this.state.checkedArray
        let selected = this.state.selected;
        let status = index in selected ? !selected[index] : true
        selected[index] = status
        if (!checkedArray.includes(index)) {
            checkedArray.push(index)
        } else {
            checkedArray = checkedArray.filter(item => item != index)
        }
        console.log(checkedArray, "checkedArray::")
        this.setState({ selected: selected, checkedArray });
    }

    checkboxAll = async () => {
        let selected = this.state.selected;
        let select = !this.state.select;
        var checkedArray = []
        await this.state.tableData.map(async (item, index) => {
            if (item.BGRequestStatus != 6 && item.BGRequestStatus === null) {
                if (select == true) {
                    await checkedArray.push(item)
                } else {
                    checkedArray = []
                }
            }
        });
        console.log(checkedArray, "jgvvgvjvjvjhv")
        await this.setState({ selected: selected, select: select, checkedArray });
    }

    requestBGRequest = async () => {
        let checkedArray = this.state.checkedArray;
        for (let index = 0; index < checkedArray.length; index++) {
            toast.loading('Requesting...', {
                duration: 1000
            });
            await this.props.UpdateBGStatusforBGRequestRequest({ BGListDetailsId: checkedArray[index].BGListDetailsId, BGRequestStatus: 6, BGExtension: checkedArray[index].BGExtension, BGType: checkedArray[index].BGType, userId: AuthHandler.getUserID(), Comments: "BG_Request_Submitted", action: "BG_Request_Submission", username: AuthHandler.getUserPayLoad().fullName, activityId: (checkedArray[index].BGType == 'ABG' ? 88 : 89) });
        }
        await this.dataSync()
    }
    requestBGExtension = async () => {
        let checkedArray = this.state.checkedArray;
        for (let index = 0; index < checkedArray.length; index++) {
            toast.loading('Requesting...', {
                duration: 1000
            });
            await this.props.UpdateBGStatusforBGRequestRequest({ BGListDetailsId: checkedArray[index].BGListDetailsId, BGRequestStatus: checkedArray[index].BGRequestStatus, BGExtension: 6, BGType: checkedArray[index].BGType, userId: AuthHandler.getUserID(), Comments: "BG_Extension_Request_Submitted", action: "BG_Extension_Request_Submission", username: AuthHandler.getUserPayLoad().fullName, activityId: (checkedArray[index].BGType == 'ABG' ? 96 : 97) });
        }
        await this.dataSync()
    }

    verifyBGRequest = async (item, Comments, action, status) => {
        console.log(item, this.state.requestType, "BGItem")
        // return false;
        let err = {}

        err.comment = this.state.ActivityComment != null ? "" : "Mandatory Field"
        await this.setState({ err })

        if (Object.keys(err).length) {
            const isEmpty = Object.values(err).every((x) => x === "");
            console.log(isEmpty, "rcc");
            if (isEmpty === true) {
                if (!this.state.activityAction && this.state.activityAction != "") {
                    swal("failed to load action", { icon: "error" })
                    await this.dataSync()
                    return false;
                }
                if (!this.state.activityStatus) {
                    swal("failed to load status", { icon: "error" })
                    await this.dataSync()
                    return false;
                }
                if (!this.state.activityId) {
                    swal("failed to load activity", { icon: "error" })
                    await this.dataSync()
                    return false;
                }
                let action = this.state.activityAction
                let status = this.state.activityStatus
                let activityId = this.state.activityId
                toast.loading('Requesting...', {
                    duration: 1000
                });
                if (this.state.requestType == "BGExtension") {
                    await this.props.UpdateBGStatusforBGRequestRequest({ BGListDetailsId: item.BGListDetailsId, BGRequestStatus: item.BGRequestStatus, BGExtension: status, BGType: item.BGType, userId: AuthHandler.getUserID(), Comments: Comments, action: action, username: AuthHandler.getUserPayLoad().fullName, activityId: activityId, });
                }
                if (this.state.requestType == "BGRequest") {
                    await this.props.UpdateBGStatusforBGRequestRequest({ BGListDetailsId: item.BGListDetailsId, BGRequestStatus: status, BGExtension: item.BGExtension, BGType: item.BGType, userId: AuthHandler.getUserID(), Comments: Comments, action: action, username: AuthHandler.getUserPayLoad().fullName, activityId: activityId });

                }
                await this.dataSync()
            }
        }
    }


    async modalBGActivity(item, action, status, activity, requestType = "BGRequest") {
        let rowdata = item
        let stateVal = this.state.BGAvtivityModal;
        this.setState({ BGAvtivityModal: !stateVal, selectedBGRow: rowdata, activityAction: action, activityId: activity, activityStatus: status, requestType: requestType });
    }

    async handlecomment(e) {

        this.setState({ ActivityComment: e });
    }

    clearFilter = async () => {
        await this.setState({
            isShowFilter: false,
            searchTerm: '',
            searchFor: '',
            sortByPlantCode: [],
            sortByPo: [],
            sortByVendor: [],
            sortByWBS: [],
        })
        await this.filterData()
    }
    toggleFilter = async () => {
        this.setState({ isShowFilter: !this.state.isShowFilter })
    }
    getFilterList = async () => {
        await this.props.GetFilterList()
        let finalvendorlist = []
        let finalpos = []
        let finalwbsno = []
        let finalplantcode = []
        await this.props.filterList[1].map(async (item) => {
            await finalplantcode.push({ label: item.PlantCode, value: item.PlantCode })
        })
        await this.props.filterList[2].map(async (item) => {
            await finalwbsno.push({ label: item.WBSCode, value: item.WBSCode })
        })
        await this.props.filterList[3].map(async (item) => {
            await finalvendorlist.push({ label: item.VendorName, value: item.VendorName })
        })
        await this.props.filterList[4].map(async (item) => {
            await finalpos.push({ label: item.POSAPId, value: item.POSAPId })
        })
        await this.setState({ finalvendorlist, finalpos, finalwbsno, finalplantcode })
    }
    handleSelectVendor = async (e) => {
        let sortByVendor = []
        let VendorName = []
        if (e.length > 0) {
            e.map((item) => {
                sortByVendor.push(item.value)
                VendorName.push(item)
            })
        }
        await this.setState({ sortByVendor, VendorName })
        await this.filterData()
    }
    handleSelectPlantCode = async (e) => {
        let sortByPlantCode = []
        let PlantCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPlantCode.push(item.value)
                PlantCode.push(item)
            })
        }
        await this.setState({ sortByPlantCode, PlantCode })
        await this.filterData()
    }
    handleSelectPO = async (e) => {
        let sortByPo = []
        let POSAPId = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPo.push(item.value)
                POSAPId.push(item)
            })
        }
        await this.setState({ sortByPo, POSAPId })
        await this.filterData()
    }
    handleSelectWBS = async (e) => {
        let sortByWBS = []
        let WBSCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByWBS.push(item.value)
                WBSCode.push(item)
            })
        }
        await this.setState({ sortByWBS, WBSCode })
        await this.filterData()
    }
    render() {
        var groups = AuthHandler.getGroups()
        let roles = AuthHandler.getRoles()
        console.log(groups, roles, "User group roles")
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }
        return (
            this.state.loadingData == true ?
                <Loading />
                :
                <div style={{ marginBottom: '3%' }}>
                    {/* UPDATE BG MODAL START */}
                    <Modal isOpen={this.state.addDocumentmodal} className="modal-xl mr-2">
                        <div className={"modal-bg" + (this.state.addDocumentmodal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div><h4 >Add Details</h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={(e) => this.addDocumentmodal(e)} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div >
                                <ModalBody Style="modal-body updateBGModalBody">
                                    <div className="row">
                                        <div className="col-md-2"><b>BG Date</b></div>
                                        <div className="col-md-4">
                                            <input type="date" className="form-control" placeholder="Enter Your Text Here" name="Document_Date" id="date" max={formatDate(new Date())} onChange={(e) => this.handleText(e)} value={formatDate(this.state.newRecord.Document_Date) || ""} />
                                        </div>
                                        <div className="col-md-2"><b>BG No.</b></div>
                                        <div className="col-md-4">
                                            <input type="text" className="form-control" placeholder="Gurantee No" name="Gurantee_No" min="1" onChange={(e) => this.handleText(e)} value={this.state.newRecord.Gurantee_No || ""} /></div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-2"><b>Old BG No.</b></div>
                                        <div className="col-md-4">
                                            <input type="text" className="form-control" placeholder="Enter Your Text Here" name="OLDBG_No" onChange={(e) => this.handleText(e)} value={this.state.newRecord.OLDBG_No || ""} />
                                        </div>
                                        <div className="col-md-2"><b>BG Amount</b></div>
                                        <div className="col-md-4">
                                            <div className='input-group'>
                                                <Select maxMenuHeight={500} className='modal-select' placeholder="Currency" name="Currency" value={this.state.SelectCurrencyArray} options={this.state.CurrencyArray} onChange={(e) => this.handleSelectCurrency(e)} />
                                                <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control" name="BG_Amount" min="1" value={this.state.newRecord.BG_Amount || ""} onValueChange={(value, e) => this.handlvalueText(value, e)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-2"><b>BG Expiry Date</b></div>
                                        <div className="col-md-4">
                                            <input type="date" className="form-control" placeholder="Expiry Date" name="Expiry_Date" min={formatDate(new Date())} onChange={(e) => this.handleText(e)} value={formatDate(this.state.newRecord.Expiry_Date) || ""} />
                                        </div>
                                        <div className="col-md-2"><b>Claim Expiry Date</b></div>
                                        <div className="col-md-4">
                                            <input type="date" className="form-control" placeholder="Claim Date" name="Claim_Date" min={formatDate(new Date())} onChange={(e) => this.handleText(e)} value={formatDate(this.state.newRecord.Claim_Date) || ""} />
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-2"><b>Bank Name</b></div>
                                        <div className="col-md-4">
                                            <input type="text" className="form-control" placeholder="Bank Name" name="Bank_Name" onChange={(e) => this.handleText(e)} value={this.state.newRecord.Bank_Name || ""} />
                                        </div>
                                        <div className="col-md-2"><b>Branch Email</b></div>
                                        <div className="col-md-4">
                                            <input type="text" className="form-control" placeholder="Branch Email Address" name="Branch_Email" onChange={(e) => this.handleText(e)} value={this.state.newRecord.Branch_Email || ""} />
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-2"><b>Address1</b></div>
                                        <div className="col-md-4">
                                            <input type="text" className="form-control" placeholder="Enter Address 1" name="Address_1" onChange={(e) => this.handleText(e)} value={this.state.newRecord.Address_1 || ""} />
                                        </div>
                                        <div className="col-md-2"><b>Address 2</b></div>
                                        <div className="col-md-4"><input type="text" className="form-control" placeholder="Enter Address 2" name="Address_2" onChange={(e) => this.handleText(e)} value={this.state.newRecord.Address_2 || ""} />
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-2"><b>City</b></div>
                                        <div className="col-md-4"><input type="text" className="form-control" placeholder="City" name="City" onChange={(e) => this.handleText(e)} value={this.state.newRecord.City || ""} />
                                        </div>
                                        <div className="col-md-2"><b>Pincode</b></div>
                                        <div className="col-md-4"><input type="number" className="form-control" placeholder="Pin Code" name="PinCode" min="1" onChange={(e) => this.handleText(e)} value={this.state.newRecord.PinCode || ""} />
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-2"><b>Country</b></div>
                                        <div className="col-md-4">
                                            <input type="text" className="form-control" placeholder="Country" name="Country" onChange={(e) => this.handleText(e)} value={this.state.newRecord.Country || ""} />
                                        </div>
                                        <div className="col-md-2"><b>Bussiness Area</b></div>
                                        <div className="col-md-4"><input type="number" className="form-control" placeholder="Bussiness Area" name="Bussiness_Area" min="1" onChange={(e) => this.handleText(e)} value={this.state.newRecord.Bussiness_Area || ""} />
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-2"><b>Entity Name</b></div>
                                        <div className="col-md-4">
                                            <input type="text" className="form-control" placeholder="Entity Name" name="EntityName" onChange={(e) => this.handleText(e)} value={this.state.newRecord.EntityName || ""} />
                                        </div>
                                        <div className="col-md-2"><b>BG Confirmation Remarks</b></div>
                                        <div className="col-md-4">
                                            <input type="text" name="BGConfirmationRemarks" className="form-control" value={this.state.newRecord.BGConfirmationRemarks || ""} onChange={(e) => this.handleText(e)} />
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-2"><b>Spl G/L indicator</b></div>
                                        <div className="col-md-4">
                                            <input type="text" className="form-control" placeholder="Spl G/L indicator" name="Spl_GL_Indicator" onChange={(e) => this.handleText(e)} value={this.state.newRecord.Spl_GL_Indicator || ""} />
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer">
                                    <div>
                                        <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.handleSaveItem()} type="submit">Update</button>
                                        <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => this.addDocumentmodal()} type="submit">Cancel</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    {/* UPDATE BG MODAL END */}
                    {/* BG BULK Upload MODAL starts */}
                    <Modal isOpen={this.state.bgUploadDocumentmodal} >
                        <div className={"modal-bg" + (this.state.bgUploadDocumentmodal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div><h4 >Add BG </h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={() => { this.bgUploadDocumentmodal() }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div >
                                <ModalBody Style="modal-body">
                                    <div className="row ml-2 pt-2">
                                        <div className="col-md-5"><b>Upload Excell File :</b></div>
                                        <div className="col-md-7">
                                            <input type="file" id='BGUpload' onChange={(e) => this.handleCsv(e)} />
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer">
                                    <div>
                                        <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.bgUploadDocumentmodal() }} type="submit">Cancel</button>
                                        <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.uploadCsv()} type="submit">Upload</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    {/* BG BULK Upload MODAL ENDS */}
                    {/* BG Action Modal starts */}
                    <Modal isOpen={this.state.OpenInFoModal} className="modal-xl mr-2">
                        <div className={"modal-bg" + (this.state.OpenInFoModal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div><h4 >Activity Details : {this.state.selectedBGRow.BGListDetailsId}</h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={() => { this.OpenInFoModal(this.state.selectedBGRow) }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div >
                                <ModalBody Style="modal-body">
                                    <div className="row">
                                        <div className="col">
                                            {this.props.expediting.bgRequestacton && this.props.expediting.bgRequestacton.length > 0 ?
                                                <table border="1" className="table5 table" >
                                                    <thead>
                                                        <tr className="headerbar ">
                                                            <th>Action</th>
                                                            <th>Acted By</th>
                                                            <th>Acted On</th>
                                                            <th>Acted Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {this.props.expediting.bgRequestacton.map((item, index) =>
                                                            <tr key={index} className="rows headeralign">
                                                                <td>{item.ActionName}</td>
                                                                <td>{item.FullName}</td>
                                                                <td>{item.CreatedOn ? dateFormater(item.CreatedOn) : '----'}</td>
                                                                <td>{item.CreatedOn ? formatTime(item.CreatedOn) : '----'}</td>
                                                            </tr>
                                                        )}

                                                    </tbody>
                                                </table>
                                                : <p style={{ fontWeight: 'bold', textAlign: 'center' }}>No Record Found</p>}
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                        </div>
                    </Modal>
                    {/* BG Revise Action Modal ENDS */}
                    {/* BG Activity MODAL starts */}
                    <Modal isOpen={this.state.BGAvtivityModal} >
                        <div className={"modal-bg" + (this.state.BGAvtivityModal === 'false' ? 'open' : '')}>
                            <div className="modalheads">
                                <ModalHeader HeaderStyle="modal-header">
                                    <div><h4 >{this.state.requestType == "BGExtension" ? "BG Extension Activity" : "BG Return Request Activity"} </h4></div>
                                    <button type="button" className="close" aria-label="Close" onClick={() => { this.modalBGActivity(this.state.selectedBGRow) }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </ModalHeader>
                            </div>
                            <div >
                                <ModalBody Style="modal-body">
                                    <div className="row ml-2 pt-2" style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div className="col">
                                            <p>Guarantee No : {this.state.selectedBGRow.Gurantee_No}</p>
                                            <p>BGType : {this.state.selectedBGRow.BGType}</p>
                                        </div>
                                        <div className="col-md-5"><b>Comment :</b></div>
                                        <div className="col-md-7">
                                            <input type="text" className='form-control' id='BGUpload' onChange={(e) => this.handlecomment(e.target.value)} />
                                            {this.state.err.comment != "" ? <p style={{ color: 'red', fontSize: '10px' }}>{this.state.err.comment}</p> : null}
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                            <div>
                                <ModalFooter FooterStyle="modal-footer">
                                    <div>
                                        <button className="btn2 btn-sms3 rounded-pill mt-2 ml-4 float-right" onClick={() => { this.modalBGActivity(this.state.selectedBGRow) }} type="submit">Cancel</button>
                                        <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.verifyBGRequest(this.state.selectedBGRow, this.state.ActivityComment, this.state.activityAction, this.state.activityStatus)} type="submit">Approve</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                    {/* BG Activity MODAL ENDS */}
                    <div className="mx-auto shadow">
                        <div className='row pl-5 pt-3 pr-4'>
                            <div className='col-6'></div>
                            <div className='col-6'>
                            </div>
                        </div>
                        <div className="row pl-5 pt-2">
                            <div className='col'><h2>BANK GUARANTEES</h2></div>
                            <div className='col'>
                                {groups[9] ?
                                    <>
                                        <a href={FILESERVER_ROOT_URL + "files/Documents/3328/download"} target="_blank" download className='btn2 btn-sms1 rounded-pill float-right'>Download Sample</a>
                                        <button className="btn2 btn-sms1 rounded-pill float-right" onClick={() => this.bgUploadDocumentmodal()}>Add BG</button>
                                    </>
                                    : null}
                                {groups[7] ?
                                    <button className="btn2 btn-sms1 rounded-pill float-right" disabled={this.state.checkedArray.length < 1 ? true : false} onClick={() => this.requestBGRequest()} type="button" > Request BG Return</button>
                                    : null}
                                {groups[9] && roles[8] ?
                                    <button className="btn2 btn-sms1 rounded-pill float-right" disabled={this.state.checkedArray.length < 1 ? true : false} onClick={() => this.requestBGExtension()} type="button" > Request BG Extension</button>
                                    : null}
                                {/* <CSVLink className="btn2 btn-sms1  rounded-pill float-right" data={this.state.csvData} filename='BGList'>export</CSVLink> */}
                            </div>
                            <div className='col pr-5'>
                                <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" toggleFilter={this.toggleFilter} clearFilter={this.clearFilter} filter={true} clear={true} btnName="" ShowSearchFor={true} searchForOptions={this.state.searchForOptions} searchForItem={this.state.searchForItem} SelectSearchForHandler={this.handleSelectSearchFor} />
                            </div>
                        </div>
                        {this.state.isShowFilter ?
                            <div className="row justify-content-between pb-3 pt-3 m-0 border-radius-modal filter-data pr-2 pl-2">
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Project No." isMulti value={this.state.WBSCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalwbsno} onChange={(e) => this.handleSelectWBS(e)} />
                                </div>
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Vendor" isMulti value={this.state.VendorName} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalvendorlist} onChange={(e) => this.handleSelectVendor(e)} />
                                </div>
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Plant" isMulti value={this.state.PlantCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalplantcode} onChange={(e) => this.handleSelectPlantCode(e)} />
                                </div>
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="PO No." isMulti value={this.state.POSAPId} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalpos} onChange={(e) => this.handleSelectPO(e)} />
                                </div>
                            </div>
                            : null}
                        <div className="row sticky">
                            <div className="col-md-12 centre-alligned wrap">
                                <table className="table1 mt-4">
                                    <thead className=" sticky-inner" style={{ backgroundColor: "#0989CB", color: "white" }}>
                                        <tr>
                                            <th><input type="checkbox" name="checked" checked={this.state.select} onChange={this.checkboxAll} /></th>
                                            <th scope="col" style={{ minWidth: '76px' }}>Action</th>
                                            <th scope="col" style={{ minWidth: '120px' }}>Doc. Date</th>
                                            <th scope="col" style={{ minWidth: '120px' }}>Posting Date</th>
                                            <th scope="col" style={{ minWidth: '100px' }}>BG Type</th>
                                            <th scope="col" style={{ minWidth: '100px' }}>Guarantee No.</th>
                                            <th scope="col" style={{ minWidth: '100px' }}>Currency</th>
                                            <th scope="col" style={{ minWidth: '120px' }}>Spl G/L indicator</th>
                                            <th scope="col" style={{ minWidth: '150px' }}>Business Area</th>
                                            <th scope="col" style={{ minWidth: '150px' }}>Entity Name</th>
                                            <th scope="col" style={{ minWidth: '100px' }}>BG Amount</th>
                                            <th scope="col" style={{ minWidth: '150px' }}>Old BG no.</th>
                                            <th scope="col">Vendor Code</th>
                                            <th scope="col" style={{ minWidth: '140px' }}>Expiry date</th>
                                            <th scope="col" style={{ minWidth: '100px' }}>Purchase order no.</th>
                                            <th scope="col" style={{ minWidth: '140px' }}>Claim Date</th>
                                            <th scope="col" style={{ minWidth: '140px' }}>Bank Name</th>
                                            <th scope="col" style={{ minWidth: '140px' }}>Branch Email</th>
                                            <th scope="col">Address 1</th>
                                            <th scope="col">Address 2</th>
                                            <th scope="col">City</th>
                                            <th scope="col">Pincode</th>
                                            <th scope="col">Country</th>
                                            <th scope="col" style={{ minWidth: '200px' }}>Supplier Name</th>
                                            <th scope="col" style={{ minWidth: '250px' }}>BG Confirmation Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.tableData.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        {groups[7] ?
                                                            <div>
                                                                <input type="checkbox" name="checked" checked={this.state.checkedArray.includes(item) ? true : false} value=""
                                                                    onChange={(event) => {
                                                                        this.changeCheckBoxStatus(item)
                                                                    }
                                                                    } hidden={item.BGRequestStatus != 6 && (item.BGRequestStatus == 3 || item.BGRequestStatus === null) ? false : true} />
                                                            </div>
                                                            : groups[9] && roles[8] ?
                                                                <div>
                                                                    <input type="checkbox" name="checked" checked={this.state.checkedArray.includes(item) ? true : false} value=""
                                                                        onChange={(event) => {
                                                                            this.changeCheckBoxStatus(item)
                                                                        }
                                                                        } hidden={item.BGExtension == 0 || item.BGExtension == 8 || item.BGExtension == 9 || item.BGExtension === null ? false : true} />
                                                                </div>
                                                                : null
                                                        }
                                                    </td>

                                                    <td>
                                                        <>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                {groups[9] ?
                                                                    <>
                                                                        <FontAwesomeIcon icon="pen-square" onClick={() => this.addDocumentmodal(item, index)} cursor="pointer" title="Edit" size="lg" color='rgb(9, 137, 203)' />
                                                                        {getDifferenceInDays(item.Expiry_Date) <= 45 ? <FontAwesomeIcon className='ml-2' icon="exclamation-triangle" color='red' size='lg' title='Need Attention' cursor='pointer' /> : null}
                                                                    </> : null}
                                                                {item.BGRequestStatus !== null || item.BGExtension !== null ?
                                                                    <FontAwesomeIcon icon="info-circle" onClick={() => this.OpenInFoModal(item)} cursor="pointer" title="info" size="lg" color='#000' />
                                                                    : ""
                                                                }
                                                                {item.BGRequestStatus !== null ?
                                                                    <>
                                                                        {groups[8] && (item.BGRequestStatus == 6 && item.BGRequestStatus !== null && item.BGType == "ABG" || (item.BGRequestStatus == 5 || item.BGRequestStatus == 4) && item.BGRequestStatus !== null && item.BGType == "PBG") ?
                                                                            <div>
                                                                                <FontAwesomeIcon icon="check-circle" onClick={() => this.modalBGActivity(item, "BG_Request_Approved_BY_ApTeam", 1, 90)} cursor="pointer" title="Approve" size="lg" color='green' />
                                                                                <FontAwesomeIcon icon="times-circle" onClick={() => this.modalBGActivity(item, "BG_Request_Rejected_BY_ApTeam", 3, 91)} cursor="pointer" title="Reject" size="lg" color='red' />
                                                                            </div>
                                                                            : groups[19] && item.BGRequestStatus == 6 && item.BGRequestStatus !== null && item.BGType == "PBG" ?
                                                                                <div>
                                                                                    <FontAwesomeIcon icon="check-circle" onClick={() => this.modalBGActivity(item, "BG_Request_Approved_BY_PMTeam", 4, 94)} cursor="pointer" title="Approve" size="lg" color='green' />
                                                                                    <FontAwesomeIcon icon="times-circle" onClick={() => this.modalBGActivity(item, "BG_Request_Rejected_BY_PMTeam", 3, 95)} cursor="pointer" title="Reject" size="lg" color='red' />
                                                                                </div>
                                                                                : groups[9] && (item.BGRequestStatus == 1 || item.BGRequestStatus == 2) && item.BGRequestStatus !== null ?
                                                                                    <div>
                                                                                        <FontAwesomeIcon icon="check-circle" onClick={() => this.modalBGActivity(item, "BG_Request_Approved_BY_Tresurry", 7, 92)} cursor="pointer" title="Approve" size="lg" color='green' />
                                                                                        <FontAwesomeIcon icon="times-circle" onClick={() => this.modalBGActivity(item, "BG_Request_Rejected_BY_Tresurry", 3, 93)} cursor="pointer" title="Reject" size="lg" color='red' />
                                                                                    </div>
                                                                                    : null}
                                                                    </>
                                                                    : null}
                                                                {item.BGExtension !== null ?
                                                                    <>
                                                                        {groups[8] && roles[8] && (item.BGExtension == 6 && item.BGExtension !== null && item.BGType == "ABG" || (item.BGExtension == 7 || item.BGExtension == 4) && item.BGExtension !== null && item.BGType == "PBG") ?
                                                                            <div>
                                                                                <FontAwesomeIcon icon="check-circle" onClick={() => this.modalBGActivity(item, "BG_Extension_Approved_BY_ApTeam", 1, 98, "BGExtension")} cursor="pointer" title="Approve" size="lg" color='green' />
                                                                                <FontAwesomeIcon icon="times-circle" onClick={() => this.modalBGActivity(item, "BG_Extension_Rejected_BY_ApTeam", 8, 99, "BGExtension")} cursor="pointer" title="Reject" size="lg" color='red' />
                                                                            </div>
                                                                            : groups[7] && roles[7] && item.BGExtension == 1 && item.BGExtension !== null && item.BGType == "ABG" ?
                                                                                <div>
                                                                                    <FontAwesomeIcon icon="check-circle" onClick={() => this.modalBGActivity(item, "BG_Extension_Approved_BY_Expidtor", 2, 100, "BGExtension")} cursor="pointer" title="Approve" size="lg" color='green' />
                                                                                    <FontAwesomeIcon icon="times-circle" onClick={() => this.modalBGActivity(item, "BG_Extension_Rejected_BY_Expidtor", (parseFloat(item.BG_Amount) < 2500000 ? 3 : 8), 101, "BGExtension")} cursor="pointer" title="Reject" size="lg" color='red' />
                                                                                </div>
                                                                                : groups[11] && roles[10] && item.BGExtension == 3 && item.BGExtension !== null && item.BGType == "ABG" ?
                                                                                    <div>
                                                                                        <FontAwesomeIcon icon="check-circle" onClick={() => this.modalBGActivity(item, "BG_Extension_Approved_BY_SCM", 4, 102, "BGExtension")} cursor="pointer" title="Approve" size="lg" color='green' />
                                                                                        <FontAwesomeIcon icon="times-circle" onClick={() => this.modalBGActivity(item, "BG_Extension_Rejected_BY_SCM", 8, 103, "BGExtension")} cursor="pointer" title="Reject" size="lg" color='red' />
                                                                                    </div>
                                                                                    : groups[19] && item.BGExtension == 6 && item.BGExtension !== null && item.BGType == "PBG" ?
                                                                                        <div>
                                                                                            <FontAwesomeIcon icon="check-circle" onClick={() => this.modalBGActivity(item, "BG_Extension_Approved_BY_PMTeam", 5, 104, "BGExtension")} cursor="pointer" title="Approve" size="lg" color='green' />
                                                                                            <FontAwesomeIcon icon="times-circle" onClick={() => this.modalBGActivity(item, "BG_Extension_Rejected_BY_PMTeam", 7, 105, "BGExtension")} cursor="pointer" title="Reject" size="lg" color='red' />
                                                                                        </div>
                                                                                        : groups[9] && (((item.BGExtension == 4 || item.BGExtension == 2) && item.BGExtension !== null && item.BGType == "ABG") || ((item.BGExtension == 5 || item.BGExtension == 1) && item.BGExtension !== null && item.BGType == "PBG")) ?
                                                                                            <div>
                                                                                                <FontAwesomeIcon icon="check-circle" onClick={() => this.modalBGActivity(item, "BG_Extension_Approved_BY_Tresurry", 9, 106, "BGExtension")} cursor="pointer" title="Approve" size="lg" color='green' />
                                                                                            </div>
                                                                                            : null}
                                                                    </>
                                                                    : null}

                                                            </div>
                                                            {item.BGRequestStatus == 7 ? <p style={{ fontSize: '8px', color: '#fff', borderRadius: '25px', textAlign: 'center', marginTop: '2px', marginBottom: '0px', backgroundColor: 'green' }}>Fully Approved</p> : item.BGRequestStatus == 3 ? <p style={{ fontSize: '8px', color: '#fff', borderRadius: '25px', textAlign: 'center', marginTop: '2px', marginBottom: '0px', backgroundColor: 'red' }}>Fully Rejected</p> : null}
                                                        </>
                                                    </td>
                                                    <td>{dateFormater(item.Document_Date)}</td>
                                                    <td>{item.approvedOn}</td>
                                                    <td>{item.BGType}</td>
                                                    <td>{item.Gurantee_No}</td>
                                                    <td>{item.Currency}</td>
                                                    <td>{item.Spl_GL_Indicator}</td>
                                                    <td>{item.Bussiness_Area}</td>
                                                    <td>{item.EntityName}</td>
                                                    <td>{numberWithCommas(item.BG_Amount)}</td>
                                                    <td>{item.OLDBG_No}</td>
                                                    <td>{item.VendorSAPId}</td>
                                                    <td style={{ backgroundColor: getDifferenceInDays(item.Expiry_Date) <= 45 ? "#eed40b" : "" }}>{dateFormater(item.Expiry_Date)}</td>
                                                    <td>{item.PurchaseOrderNo}</td>
                                                    <td>{dateFormater(item.Claim_Date)}</td>
                                                    <td>{item.Bank_Name}</td>
                                                    <td>{item.Branch_Email}</td>
                                                    <td>{item.Address_1}</td>
                                                    <td>{item.Address_2}</td>
                                                    <td>{item.City}</td>
                                                    <td>{item.PinCode}</td>
                                                    <td>{item.Country}</td>
                                                    <td>{item.SupplierName}</td>
                                                    <td>{item.BGConfirmationRemarks}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}

const mapStateToProps = (state) => ({ expediting: state.expediting, filterList: state.masterReducer.filterList, poDetails: state.poDetails })
export default connect(mapStateToProps, { getBGListDetails, postBGListDetails, UpdateBGStatusforBGRequestRequest, GetFilterList, uploadBG, getProjectAllocationByUserId, getactionDetail })(BGList)